import React, { useContext, useState, useEffect } from 'react'

import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import CustomCommonContext from '../../custom/context/common/commonContext'
import { handleRedirectInternal, mapData } from '@/product/common/components'

import {
    dateFormatFunction,
    dateTimeFormatFunction,
    currencyFormat,
    capitalize,
    paymentTypeRosoom,
} from '../../custom/common/components'
import { useFormik } from 'formik'
import { Button, Divider } from '@mui/material'
import CartItem from './cartItem'
import { LOGO, SITE_NAME } from '@/utils/UI/index'
import Layout from '@/product/components/templates/Layout'
import './invoice.css'
import ProductContext from '@/product/context/product/productContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import * as Yup from 'yup'
import BarCodeScan from '@/product/components/organisms/BarCodeScan'
import AlertContext from '@/product/context/alert/alertContext'
import { useHistory } from 'react-router-dom'
import Loaders from '@/product/components/molecules/Loaders'
import SettingContext from '@/product/context/setting/settingContext'
import { TrainRounded } from '@mui/icons-material'
import CustomTable from '@/product/components/molecules/CustomTable'

const InvoiceView = (props) => {
    const customCommonContext = useContext(CustomCommonContext)
    const { allConfigurationVariables, currentLanguage, allLocations } =
        customCommonContext

    const productContext = useContext(ProductContext)
    const {
        all_products,
        getAllProducts,
        responseStatus: responseStatusProduct,
        clearResponse: clearResponseProduct,
    } = productContext

    const invoiceContext = useContext(InvoiceContext)
    const {
        single_invoice,
        getSingleInvoice,
        updateInvoice,
        all_invoices,
        changeProductStatus,
        responseStatus: updateInvoiceResponseStatus,
    } = invoiceContext
    const settingcontext = useContext(SettingContext)

    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const alertContext = useContext(AlertContext)
    const history = useHistory()
    const { setAlert } = alertContext

    const [viewContent, setViewContent] = React.useState(null)
    const [print, setPrint] = useState(false)
    const [reload, setReload] = useState(false)
    const [intialPickedupLoad, setIntialPickedupLoad] = useState(false)
    const [addMoreItems, setAddMoreItems] = useState(false)
    const [allActiveItems, setAllActiveItems] = useState([])
    const [scanToggle, setScanToggle] = useState(false)
    const [searchText, setSearchText] = useState('')
    const [qtyOptions, setQtyOptions] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [taxEditPopup, setTaxEditPopup] = useState(false)
    const [logsBody, setLogsBody] = useState([])
    const [tableAllLogsBody, setTableAllLogsBody] = useState({
        records: [],
        totalRecords: 0,
        setDisp: '',
    })

    const changeTaxEditPopup = () => {
        setTaxEditPopup(!taxEditPopup)
    }

    const data = props.data
    let invoiceID =
        props.winnerInvoiceId ||
        (props.match?.params?.id ? +props.match.params.id : 0)
    let userId =
        props.winnerUserId ||
        (props.match?.params?.uid ? +props.match.params.uid : 0)
    let action = props.match?.params?.action ? props.match.params.action : 0
    const toggleFullScreenPopup = props.function

    const formik = useFormik({
        initialValues: {
            cart_id: 0,
        },
        validateOnBlur: false,
    })

    // temp lang Manager
    const t = (text) => {
        text = text.charAt(0).toUpperCase() + text.slice(1)
        return text.replace(/_/g, ' ')
    }

    useEffect(() => {
        resetFrom()
    }, [props])

    useEffect(() => {
        setIsLoading(true)
        if (invoiceID && userId) {
            formik.values.invoice_id = invoiceID
            formik.values.user_id = userId
            buynowLogsFormik.values.filters.common_invoice.value = invoiceID
            if (action === 'cancel') {
                formik.values.filters = {
                    active: {
                        type: 'in',
                        field: 'b.active',
                        value: 2,
                    },
                }
            } else if (action === 'all') {
                formik.values.filters = {
                    active2: {
                        type: 'notin',
                        field: 'b.active',
                        value: 3,
                    },
                }
            } else {
                formik.values.filters = {
                    active: {
                        type: 'notin',
                        field: 'b.active',
                        value: 2,
                    },
                }
            }
            getSingleInvoice(formik.values, 'viewInvoice')
            searchTableFetch(buynowLogsFormik.values, 'buynow_logs')
        }
        //  else {
        //     resetFrom()
        // }
    }, [invoiceID, userId])
    let [invoiceDetails, setInvoiceDetails] = useState({
        invoiceProducts: [],
        cartValues: {},
        appointmentDetail: {},
        locationDetail: {},
        invoiceTransactions: [],
        returnTransactions: [],
        invoiceUser: [],
        invoiceAddress: [],
    })

    useEffect(() => {
        if (single_invoice && single_invoice.from === 'viewInvoice') {
            setInvoiceDetails({
                invoiceProducts: single_invoice.invoicerecords.length
                    ? single_invoice.invoicerecords
                    : [],
                cartValues: single_invoice.cartvalues,
                appointmentDetail: single_invoice.appointmentrecord,
                locationDetail: single_invoice.locationrecord,
                invoiceTransactions: single_invoice.transactionrecords,
                returnTransactions: single_invoice.returnTransactions,
                invoiceUser: single_invoice.invoiceuserrecord,
                invoiceAddress: single_invoice.invoiceaddressrecord,
            })
            setIsLoading(false)
            // formikCheckbox.values.picked_up = single_invoice.invoicerecords[0]
            //     .delivered
            //     ? true
            //     : false
        }
    }, [single_invoice])

    const logsTableBody = [
        {
            field: 'project_id',
            type: '',
            sort: true,
            filterable: true,
            label: 'Lot #',
            firstChild: true,
            disablePadding: false,
            sortField: 'bl.project_id',
            filterField: 'bl.project_id',
        },
        {
            field: 'previous_per_total',
            type: 'price',
            sort: true,
            filterable: true,
            label: 'Per Total',
            firstChild: true,
            disablePadding: false,
            sortField: 'bl.previous_per_total',
            filterField: 'bl.previous_per_total',
        },
        {
            field: 'previous_total_tax',
            type: 'price',
            sort: true,
            filterable: true,
            label: 'Sales Tax',
            firstChild: true,
            disablePadding: false,
            sortField: 'bl.previous_total_tax',
            filterField: 'bl.previous_total_tax',
        },
        {
            field: 'previous_total_amount',
            type: 'price',
            sort: true,
            filterable: true,
            label: 'Total Amount',
            firstChild: true,
            disablePadding: false,
            sortField: 'bl.previous_total_amount',
            filterField: 'bl.previous_total_amount',
        },
        {
            field: 'change_notes',
            type: 'text',
            sort: false,
            filterable: true,
            label: 'Change Notes',
            firstChild: true,
            disablePadding: false,
            sortField: 'bl.change_notes',
            filterField: 'bl.change_notes',
        },
        {
            field: 'created_at',
            type: 'datetime',
            sort: true,
            filterable: true,
            label: 'Date/Time',
            firstChild: true,
            disablePadding: false,
            sortField: 'bl.created_at',
            filterField: 'bl.created_at',
        },
        {
            field: 'as_employees_emp_firstname,as_employees_emp_lastname',
            type: 'text',
            firstChild: false,
            sort: TrainRounded,
            disablePadding: false,
            label: 'Updated By',
        },
    ]

    useEffect(() => {
        setInvoiceDetails({
            invoiceProducts: [],
            cartValues: {},
            appointmentDetail: {},
            locationDetail: {},
            invoiceTransactions: [],
            returnTransactions: [],
            invoiceUser: [],
            invoiceAddress: [],
        })
        return () => {
            setInvoiceDetails({
                invoiceProducts: [],
                cartValues: {},
                appointmentDetail: {},
                locationDetail: {},
                invoiceTransactions: [],
                returnTransactions: [],
                invoiceUser: [],
                invoiceAddress: [],
            })
        }
    }, [])
    const resetFrom = () => {
        setViewContent(null)
    }

    const ref = React.createRef()
    const options = {}

    const generatePDF = (toPdf) => {
        setPrint(true)
        toPdf()
    }
    const completedPDF = () => {
        setPrint(false)
    }

    // const formikCheckbox = useFormik({
    //     initialValues: {
    //         picked_up: false,
    //     },
    //     onSubmit: (values) => {
    //         console.log('handle checked submit ', values)
    //     },
    // })

    // const mapDataOptions = {
    //     formik: formikCheckbox,
    //     data: [
    //         {
    //             label: 'Mark Item as Picked Up',
    //             type: 'checkbox',
    //             class: 'col-12',
    //             name: 'picked_up',
    //         },
    //     ],
    // }

    // useEffect(() => {
    //     if (data.id) {
    //         let payload = {
    //             action: formikCheckbox.values.picked_up
    //                 ? 'delivered'
    //                 : 'undelivered',
    //             project_id: [invoiceDetails.invoiceProducts[0]?.id],
    //         }
    //         if (intialPickedupLoad && payload.project_id[0]) {
    //             changeProductStatus(payload)
    //         }

    //         setIntialPickedupLoad(true)
    //     }
    // }, [formikCheckbox.values.picked_up, data.id])

    const addMoreItemsValidation = Yup.object({
        lpn_number: Yup.string().required('Required!'),
        project_id: Yup.number()
            .integer("Can't be a decimal")
            .required('Required!')
            .positive('Should be greater than 0'),
        qty: Yup.string().required('Required!'),
        // qty: Yup.number()
        //     .integer("Can't be a decimal")
        //     .required('Required!')
        //     .positive('Should be greater than 0')
    })

    const addMoreItemsFormik = useFormik({
        initialValues: {
            invoice_id: invoiceID,
            project_id: 0,
            user_id: userId,
            addMoreInvoiceItems: true,
            qty: '',
            lpn_number: '',
            product_title: '',
        },
        validateOnBlur: false,
        validationSchema: addMoreItemsValidation,
        onSubmit: (values) => {
            values.partial = invoiceDetails.cartValues.total_paid ? 1 : 0
            values.addMoreInvoiceItems = true
            console.log('added items ', values)
            updateInvoice(values)
        },
    })

    const clearAddMoreItemsFormik = () => {
        addMoreItemsFormik?.setValues(addMoreItemsFormik?.initialValues)
        addMoreItemsFormik?.setTouched({}, false)
        setQtyOptions([])
    }

    const handleCloseMoreItems = () => {
        clearAddMoreItemsFormik()
        setAddMoreItems(false)
    }

    const itemsQuantityField = [
        {
            label: 'Select Available Quantity',
            placeholder: 'Select Available Quantity',
            type: 'select',
            class: `${qtyOptions.length ? 'col-12' : 'd-none'}`,
            name: 'qty',
            size: 'small',
            formik: addMoreItemsFormik,
            options: qtyOptions,
        },
    ]

    const createArrayObjects = (num) => {
        return Array.from({ length: num }, (_, index) => ({
            show: index + 1,
            value: index + 1,
        }))
    }

    const validationTaxEdit = Yup.object({
        buynowId: Yup.string().trim().required('Required!'),
        per_total: Yup.number()
            .typeError('Must be a number')
            .test('is-decimal', 'Invalid Value', (value) => {
                if (value) {
                    return /^\d+(\.\d{1,3})?$/.test(value.toString())
                } else {
                    return true
                }
            }),
        change_notes: Yup.string().required('Required!'),
    })

    const formikTaxEdit = useFormik({
        initialValues: {
            user_id: 0,
            buynowId: 0,
            per_total: 0,
            change_amount: true,
            custom_tax_name: 'zipperbuy_custom_tax',
            change_notes: '',
        },
        validationSchema: validationTaxEdit,
        onSubmit: (values) => {
            console.log('changeAmountFormik Values', values)
            values.per_total = parseFloat(values.per_total)
            if (values.buynowId) {
                updateInvoice(values)
            }
        },
    })
    console.log('formikTaxEdit', formikTaxEdit)

    const taxEditField = [
        {
            label: 'Change Notes',
            placeholder: 'Change Notes',
            type: '',
            class: 'col-12',
            name: 'change_notes',
            formik: formikTaxEdit,
            autoFocus: true,
        },
        {
            label: 'Amount',
            placeholder: 'Enter the Amount',
            type: 'text',
            class: 'col-12',
            name: 'per_total',
            startAdornment: (
                <span className="material-icons">attach_money</span>
            ),
            formik: formikTaxEdit,
        },
    ]

    const handleChangeAmount = (data, action) => {
        if (action === 'changeAmount') {
            console.log('i am here amount edit ', data)
            formikTaxEdit.setFieldValue('buynowId', data.id)
            formikTaxEdit.setFieldValue('buynow_autype', data.buynow_autype)
            formikTaxEdit.setFieldValue('per_total', data.per_total || 0)
            formikTaxEdit.setFieldValue('user_id', data?.user_id || 0)
            setReload(!reload)
            setTaxEditPopup(true)
        } else if (action === 'closePopup') {
            changeTaxEditPopup()
            formikTaxEdit.setValues(formikTaxEdit.initialValues)
            formikTaxEdit.setTouched({}, false)
        }
    }

    const buynowLogsFormik = useFormik({
        initialValues: {
            page: 1,
            limit: 5,
            order: 'desc',
            orderby: 'bl.id',
            filters: {
                common_invoice: {
                    value: 0,
                    type: 'in',
                    field: 'bl.common_invoice',
                },
            },
            primaryTable: 'buynow_logs',
            tableJoins: [
                {
                    baseTable: 'employees',
                    joinType: 'left',
                    baseJoinField: 'id',
                    connectJoinField: 'admin_id',
                },
            ],
        },
        onSubmit: (values) => {
            setIsLoading(true)
            searchTableFetch(values, 'buynow_logs')
        },
    })

    useEffect(() => {
        if (updateInvoiceResponseStatus) {
            if (
                updateInvoiceResponseStatus.status === 'success' &&
                updateInvoiceResponseStatus.from === 'invoiceupdate'
            ) {
                if (addMoreItems) {
                    handleCloseMoreItems()
                    addMoreItemsFormik.setValues(
                        addMoreItemsFormik.initialValues
                    )
                    addMoreItemsFormik.setTouched({}, false)
                    getSingleInvoice(formik.values, 'viewInvoice')
                }
                if (taxEditPopup) {
                    setTaxEditPopup(false)
                    formikTaxEdit.setValues(formikTaxEdit.initialValues)
                    formikTaxEdit.setTouched({}, false)
                    getSingleInvoice(formik.values, 'viewInvoice')
                    searchTableFetch(buynowLogsFormik.values, 'buynow_logs')
                }
            }
        }
    }, [updateInvoiceResponseStatus])

    useEffect(() => {
        if (search_fetch_data && search_fetch_data.from === 'buynow_logs') {
            console.log('search_fetch_data ', search_fetch_data)
            setIsLoading(false)
            setLogsBody(
                search_fetch_data.records.length
                    ? search_fetch_data.records
                    : []
            )
            setTableAllLogsBody(search_fetch_data)
        }
    }, [search_fetch_data])

    const fileValidationArray = Yup.object({
        file_path: Yup.array().when('content_type', {
            is: 'file',
            then: Yup.array().required('Required!'),
        }),
    })

    const fileFormik = useFormik({
        initialValues: {
            file_path: [],
        },
        validationSchema: fileValidationArray,
        onSubmit: (values) => {},
    })

    const handleScanProduct = () => {
        setScanToggle(true)
    }

    const changeScanDialogStatus = () => {
        fileFormik.resetForm()
        setScanToggle(!scanToggle)
    }

    const setDecodedBarcode = (data) => {
        setSearchText(data)
        if (data && data !== '') {
            getAllProducts(
                {
                    limit: 1,
                    page: 1,
                    orderby: 'p.id, desc',
                    order: '',
                    filters: {
                        product_id: {
                            value: data,
                            type: 'in',
                            field: 'it.scan_lpn_number',
                        },
                        location: {
                            value: invoiceDetails.invoiceProducts[0]
                                ?.custom_projects_location,
                            type: 'in',
                            field: 'it.location',
                        },
                        buynow: {
                            value: 1,
                            type: 'in',
                            field: 'p.buynow',
                        },
                    },
                    market_status: ['open'],
                    having: {
                        future_active: {
                            value: '0',
                            type: 'in',
                            field: 'future_active',
                        },
                    },
                },
                'scan_lot'
            )
        }
    }

    const handleLpnInput = () => {
        console.log('i am handleLpnInput', addMoreItemsFormik.values.lpn_number)
        if (addMoreItemsFormik.values.lpn_number) {
            setDecodedBarcode(addMoreItemsFormik.values.lpn_number)
        } else {
            setAlert('LPN Number is required!', 'error')
        }
    }

    const handleLpnChange = (e) => {
        console.log('i am value', e)
        clearAddMoreItemsFormik()
        addMoreItemsFormik.setValues({
            lpn_number: e.target.value,
        })
    }

    const addMoreItemsFields = [
        {
            label: 'LPN Number',
            placeholder: 'Enter LPN Number',
            type: 'text',
            class: 'col-12',
            name: 'lpn_number',
            size: 'small',
            formik: addMoreItemsFormik,
            onChange: handleLpnChange,
            endAdornment: (
                <Button onClick={handleLpnInput}>
                    <span className="material-icons">search</span>
                </Button>
            ),
        },
    ]

    useEffect(() => {
        if (!addMoreItems) {
            handleCloseMoreItems()
        }
    }, [addMoreItems])

    useEffect(() => {
        if (
            all_products &&
            all_products.from === 'scan_lot' &&
            (searchText !== '' || addMoreItemsFormik.values.lpn_number !== '')
        ) {
            if (all_products?.records?.length) {
                const qtyOpt =
                    all_products?.records[0].qty - all_products?.records[0].sold
                addMoreItemsFormik.setValues({
                    project_id: all_products?.records[0].id,
                    lpn_number:
                        all_products?.records[0].scan_lpn_number.toString(),
                    invoice_id: invoiceID,
                    user_id: userId,
                    product_title: `${all_products?.records[0].title} (Available Qty - ${qtyOpt})`,
                })
                setQtyOptions(createArrayObjects(qtyOpt))
            } else {
                clearAddMoreItemsFormik()
                setAlert('LPN number not Found', 'error')
            }
        }
    }, [all_products])

    return (
        // <FullScreenPopup
        //     modaltitle={
        //         data.status === 'view' ? `VIEW INVOICE` : `EDIT INVOICE`
        //     }
        //     open={data.popup}
        //     handleClose={() => toggleFullScreenPopup(false)}
        // >
        <Layout printable={true}>
            {isLoading ? (
                <div className="fspLoader">
                    <Loaders isLoading={isLoading} />
                </div>
            ) : (
                <div className="container-lg productInvoice">
                    <h3 className="invoiceTitle">Invoice</h3>
                    <div className="d-flex justify-content-between align-items-center mb-2 noPrint">
                        <Button
                            id="invoice_arrow_back"
                            onClick={() => {
                                history.goBack()
                                window.scrollTo(0, 0)
                            }}
                            className="moveBack"
                        >
                            <span className="material-icons">arrow_back</span>
                            {'Back'}
                        </Button>
                        {/* <Breadcrumbs aria-label="breadcrumb" className="naBreadcrumbs">
                        <Link to="/dashboard/won">Dashboard</Link>
                        <Typography color="textPrimary">Invoice</Typography>
                    </Breadcrumbs> */}
                        <Button
                            id="invoice_print"
                            onClick={() => window.print()}
                        >
                            <span className="material-icons">print</span>
                            {t('print')}
                        </Button>
                    </div>
                    <div
                        className={`invoiceView ${
                            print ? 'invoiceViewPrint' : ''
                        }`}
                        ref={ref}
                        style={{ height: '100%', width: '100%' }}
                    >
                        <div className="card-header">
                            <div className="row">
                                <div className="col-md-6 text-left">
                                    <a
                                        className="pt-2 d-inline-block"
                                        data-abc="true"
                                    >
                                        <img
                                            src={LOGO}
                                            className="invLogo"
                                            alt={SITE_NAME}
                                            style={{ width: '240px' }}
                                        />
                                    </a>
                                    <div>
                                        <p className="text-dark  mt-2 mb-0">
                                            {SITE_NAME}
                                        </p>
                                        {allConfigurationVariables?.brand_phone && (
                                            <p className="text-dark  mt-2 mb-0 d-none">
                                                {allConfigurationVariables?.brand_phone ||
                                                    ''}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h2 className="text-center taxInvoiceHeader">
                            INVOICE
                        </h2>
                        <div className="card-body">
                            <div className="row mb-4">
                                {invoiceDetails.invoiceUser?.length ? (
                                    <div
                                        className={`col-md-6 invAddr ${
                                            currentLanguage === 'for_arabic'
                                                ? 'text-right'
                                                : 'text-left'
                                        }`}
                                    >
                                        <p className="textBold">
                                            Customer Details
                                        </p>
                                        <p className="cstmrNameTxt">
                                            {
                                                invoiceDetails.invoiceUser[0]
                                                    .first_name
                                            }{' '}
                                            {
                                                invoiceDetails.invoiceUser[0]
                                                    .last_name
                                            }
                                        </p>

                                        <>
                                            <p>
                                                {invoiceDetails.invoiceUser[0]
                                                    .address1 &&
                                                    invoiceDetails
                                                        .invoiceUser[0]
                                                        .address1}
                                            </p>
                                            <p>
                                                {invoiceDetails.invoiceUser[0]
                                                    .address2 &&
                                                    invoiceDetails
                                                        .invoiceUser[0]
                                                        .address2}
                                            </p>
                                            {invoiceDetails.invoiceUser[0]
                                                .city &&
                                                invoiceDetails.invoiceUser[0]
                                                    .state &&
                                                invoiceDetails.invoiceUser[0]
                                                    .country && (
                                                    <p>
                                                        {
                                                            invoiceDetails
                                                                .invoiceUser[0]
                                                                .city
                                                        }
                                                        ,{' '}
                                                        {/* {invoiceDetails.invoiceUser[0].state},{' '} */}
                                                        <br />
                                                        {
                                                            invoiceDetails
                                                                .invoiceUser[0]
                                                                .country
                                                        }{' '}
                                                        -{' '}
                                                        {
                                                            invoiceDetails
                                                                .invoiceUser[0]
                                                                .zip
                                                        }
                                                    </p>
                                                )}
                                        </>
                                    </div>
                                ) : null}
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-5 col-xs-5">
                                            <p className="m-0 textBold">
                                                Invoice Number
                                            </p>
                                        </div>
                                        <div className="col-md-1 col-xs-1 textBold">
                                            :
                                        </div>
                                        <div className="col-md-6 col-xs-6">
                                            <p className="m-0">
                                                {
                                                    invoiceDetails.cartValues
                                                        .common_invoice
                                                }
                                            </p>
                                        </div>
                                        {invoiceDetails.cartValues
                                            .cart_paiddate ||
                                        invoiceDetails.invoiceProducts[0]
                                            ?.returned_date ? (
                                            <>
                                                <div className="col-md-5 col-xs-5">
                                                    <p className="m-0 textBold">
                                                        Invoice Date
                                                    </p>
                                                </div>
                                                <div className="col-md-1 col-xs-1 textBold">
                                                    :
                                                </div>
                                                <div className="col-md-6 col-xs-6">
                                                    <p className="m-0">
                                                        {invoiceDetails
                                                            .invoiceProducts[0]
                                                            ?.active === 2
                                                            ? dateTimeFormatFunction(
                                                                  invoiceDetails
                                                                      .invoiceProducts[0]
                                                                      ?.returned_date
                                                              )
                                                            : dateTimeFormatFunction(
                                                                  invoiceDetails
                                                                      .cartValues
                                                                      .cart_paiddate
                                                              )}
                                                        {/* {dateFormatFront(
                                                    invoiceDetails.cartValues.cart_paiddate,
                                                )} */}
                                                    </p>
                                                </div>
                                            </>
                                        ) : null}

                                        <div className="col-md-5 col-xs-5">
                                            <p className="m-0 textBold">
                                                Invoice Status:
                                            </p>
                                        </div>
                                        <div className="col-md-1 col-xs-1 textBold">
                                            :
                                        </div>
                                        <div className="col-md-6 col-xs-6">
                                            <p className="m-0">
                                                {invoiceDetails
                                                    .invoiceProducts[0]
                                                    ?.active === 2
                                                    ? 'Cancelled'
                                                    : invoiceDetails.cartValues
                                                            .cart_paid
                                                      ? 'Paid'
                                                      : invoiceDetails
                                                              .cartValues
                                                              .total_paid
                                                        ? 'Partial'
                                                        : 'Unpaid'}
                                                {/* {invoiceDetails.cartValues.cart_paid ? 'Paid' : 'Unpaid'} */}
                                            </p>
                                        </div>
                                        {/* <div className="col-md-5">
                                    <p className="m-0 textBold">Currency</p>
                                </div>
                                <div className="col-md-1 textBold">:</div>
                                <div className="col-md-6">
                                    <p className="m-0">$</p>
                                </div> */}
                                    </div>
                                </div>
                                {invoiceDetails.invoiceUser?.length ? (
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-5 col-xs-5">
                                                <p className="textBold d-flex justify-content-between">
                                                    Phone
                                                </p>
                                            </div>
                                            <div className="col-md-1 col-xs-1 textBold">
                                                :
                                            </div>
                                            <div className="col-md-6 col-xs-6">
                                                <p>
                                                    {
                                                        invoiceDetails
                                                            .invoiceUser[0]
                                                            .phone
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                                {/* {invoiceDetails.appointmentDetail ? (
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-5">
                                        <p className="m-0 textBold">Appointment</p>
                                    </div>
                                    <div className="col-md-1 textBold">:</div>
                                    <div className="col-md-6">
                                        <p className="m-0">
                                            {dateTimeFormatFunction(
                                                invoiceDetails.appointmentDetail.appointmentTime,
                                            )}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ) : null} */}
                                {invoiceDetails.invoiceUser?.length ? (
                                    <>
                                        <div className="col-md-1 col-xs-6">
                                            <p className="textBold d-flex justify-content-between">
                                                Email <span>:</span>
                                            </p>
                                        </div>
                                        <div className="col-md-5 col-xs-6">
                                            <p>
                                                {
                                                    invoiceDetails
                                                        .invoiceUser[0].email
                                                }
                                            </p>
                                        </div>
                                        <div className="col-md-6 col-xs-1"></div>
                                    </>
                                ) : null}
                            </div>

                            {invoiceDetails.appointmentDetail
                                ?.appointmentTime ? (
                                <>
                                    <h4 className="invoiceSubTitle">
                                        {t('appointment_scheduled_at')}:{' '}
                                        {dateTimeFormatFunction(
                                            invoiceDetails.appointmentDetail
                                                .appointmentTime
                                        )}
                                    </h4>
                                </>
                            ) : null}
                            {invoiceDetails.invoiceProducts[0]?.active === 2 ? (
                                <>
                                    <h4 className="invoiceSubTitle text-danger">
                                        {'Invoice Cancelled: '}
                                        {
                                            invoiceDetails.invoiceProducts[0]
                                                ?.notes
                                        }
                                    </h4>
                                </>
                            ) : null}
                            {invoiceDetails.invoiceTransactions.length ? (
                                <>
                                    <h4 className="invoiceSubTitle">
                                        {t('transaction_details')}
                                    </h4>
                                    {/* <div className="row">
                                    {mapData(mapDataOptions)}
                                </div> */}
                                    {/* <div className="d-flex justify-content-end mb-3">
                                        <Button
                                            variant="outlined"
                                            onClick={() =>
                                                setAddMoreItems(true)
                                            }
                                        >
                                            <span className="material-icons">
                                                library_add
                                            </span>
                                            {'Add Item'}
                                        </Button>
                                        {!invoiceDetails?.cartValues
                                            ?.cart_paid ? (
                                            <Button
                                                variant="outlined"
                                                className="ml-2"
                                                onClick={() =>
                                                    handleRedirectInternal(
                                                        history,
                                                        `invoice/payment/${invoiceID}/${userId}`
                                                    )
                                                }
                                            >
                                                <span className="material-icons">
                                                    monetization_on
                                                </span>
                                                {'Make Payment'}
                                            </Button>
                                        ) : null}
                                    </div> */}
                                    <div className="transDet d-flex justify-content-between flex-wrap">
                                        <>
                                            <table className="table table-bordered ">
                                                <thead>
                                                    <tr>
                                                        {/* <th scope="col">S.No</th> */}
                                                        <th scope="col">
                                                            {'Transaction id'}
                                                        </th>
                                                        <th scope="col">
                                                            {'Paid on'}
                                                        </th>
                                                        <th scope="col">
                                                            {'Method'}
                                                        </th>
                                                        <th scope="col">
                                                            {'Amount'}
                                                        </th>
                                                        <th scope="col">
                                                            {'Status'}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {invoiceDetails.invoiceTransactions.map(
                                                        (data, index) => (
                                                            <tr key={index}>
                                                                <td
                                                                    data-title={
                                                                        'Transaction id'
                                                                    }
                                                                >
                                                                    {data.trans_id
                                                                        ? `# ${data.trans_id}`
                                                                        : '-'}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        minWidth:
                                                                            '112px',
                                                                    }}
                                                                    data-title={
                                                                        'Paid on'
                                                                    }
                                                                >
                                                                    {dateTimeFormatFunction(
                                                                        data.created_at
                                                                    )}
                                                                </td>
                                                                <td
                                                                    data-title={
                                                                        'Card'
                                                                    }
                                                                >
                                                                    {data.payment_method ===
                                                                    'Card' ? (
                                                                        <>
                                                                            {capitalize(
                                                                                data.payment_method
                                                                            )}{' '}
                                                                            -{' '}
                                                                            {
                                                                                data.mk_card_number
                                                                            }{' '}
                                                                            (
                                                                            {
                                                                                data.card_type
                                                                            }
                                                                            )
                                                                        </>
                                                                    ) : data.payment_method ===
                                                                      'Credit' ? (
                                                                        <>
                                                                            Wallet
                                                                        </>
                                                                    ) : data.payment_method ===
                                                                      'coupon' ? (
                                                                        <>
                                                                            Promo
                                                                            Discount
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {capitalize(
                                                                                data.payment_method
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </td>
                                                                <td
                                                                    data-title={
                                                                        'Amount'
                                                                    }
                                                                >
                                                                    {currencyFormat(
                                                                        data.amount,
                                                                        2
                                                                    )}
                                                                </td>
                                                                <td
                                                                    data-title={
                                                                        'Payment status'
                                                                    }
                                                                    style={{
                                                                        color:
                                                                            data.status ===
                                                                            'success'
                                                                                ? 'green'
                                                                                : 'red',
                                                                    }}
                                                                >
                                                                    {capitalize(
                                                                        data.status ===
                                                                            'success'
                                                                            ? 'Paid'
                                                                            : 'UnPaid'
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        )
                                                    )}
                                                </tbody>
                                            </table>
                                        </>
                                    </div>
                                </>
                            ) : null}

                            {invoiceDetails?.returnTransactions?.length ? (
                                <>
                                    <h4 className="invoiceSubTitle">
                                        {'Refund Transaction details'}
                                    </h4>
                                    <div className="transDet d-flex justify-content-between flex-wrap">
                                        <>
                                            <div className="table-responsive w-100">
                                                <table className="table table-bordered ">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">
                                                                {'Refund id'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Refund on'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Amount'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Method'}
                                                            </th>
                                                            <th scope="col">
                                                                {
                                                                    'Refund Status'
                                                                }
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {invoiceDetails.returnTransactions.map(
                                                            (data, index) => (
                                                                <tr key={index}>
                                                                    <td
                                                                        data-title={
                                                                            'Transaction id'
                                                                        }
                                                                    >
                                                                        {data.reftrans_id
                                                                            ? `# ${data.reftrans_id}`
                                                                            : 'Wallet Refund'}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            minWidth:
                                                                                '112px',
                                                                        }}
                                                                        data-title={
                                                                            'Refund on'
                                                                        }
                                                                    >
                                                                        {dateTimeFormatFunction(
                                                                            data.created_at
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        data-title={
                                                                            'Amount'
                                                                        }
                                                                    >
                                                                        {currencyFormat(
                                                                            data.amount,
                                                                            2
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        data-title={
                                                                            'Method'
                                                                        }
                                                                    >
                                                                        {data?.refund_method ===
                                                                        'stripe'
                                                                            ? 'Card'
                                                                            : 'Wallet'}
                                                                    </td>
                                                                    <td
                                                                        data-title={
                                                                            'Refund status'
                                                                        }
                                                                        style={{
                                                                            color:
                                                                                data.status ===
                                                                                'success'
                                                                                    ? 'green'
                                                                                    : 'red',
                                                                        }}
                                                                    >
                                                                        {capitalize(
                                                                            data.status ===
                                                                                'success'
                                                                                ? 'Success'
                                                                                : 'Failed'
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    </div>
                                </>
                            ) : null}

                            <h4 className="invoiceSubTitle mt-5">
                                {t('product_details')}
                            </h4>
                            <div className="table-responsive">
                                {invoiceDetails.invoiceProducts.length ? (
                                    <div className="cartProducts ll">
                                        <div>
                                            {invoiceDetails.invoiceProducts.map(
                                                (data, index) => (
                                                    <CartItem
                                                        data={data}
                                                        from="invoice"
                                                        handleChangeAmount={
                                                            handleChangeAmount
                                                        }
                                                    />
                                                )
                                            )}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                            <div className="row mt-5 invoiceTotalTable">
                                <div className="col-12">
                                    <div className="table-responsive">
                                        <table className="table table-clear nellisInvTot">
                                            <tbody>
                                                {invoiceDetails?.cartValues
                                                    ?.restocking_fee ? (
                                                    <>
                                                        <tr>
                                                            <td
                                                                className="left"
                                                                align="right"
                                                            >
                                                                <span className="text-dark">
                                                                    {t('items')}
                                                                </span>
                                                            </td>
                                                            <td className="right">
                                                                <span className="text-dark">
                                                                    {
                                                                        invoiceDetails
                                                                            .invoiceProducts
                                                                            .length
                                                                    }
                                                                </span>
                                                            </td>
                                                        </tr>

                                                        {invoiceDetails
                                                            ?.cartValues
                                                            ?.restocking_fee ? (
                                                            <tr>
                                                                <td
                                                                    className="left"
                                                                    align="right"
                                                                >
                                                                    <span className="text-dark">
                                                                        Restocking
                                                                        Fee
                                                                    </span>
                                                                </td>
                                                                <td className="right">
                                                                    <span className="text-dark">
                                                                        {currencyFormat(
                                                                            invoiceDetails
                                                                                ?.cartValues
                                                                                ?.restocking_fee
                                                                        )}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) : null}

                                                        {invoiceDetails
                                                            .invoiceProducts[0]
                                                            ?.total_coupon_discount ? (
                                                            <tr>
                                                                <td
                                                                    className="left"
                                                                    align="right"
                                                                >
                                                                    <span className="text-dark">
                                                                        {
                                                                            'Coupon Discount'
                                                                        }
                                                                    </span>
                                                                </td>
                                                                <td className="right">
                                                                    <span className="text-dark">
                                                                        {currencyFormat(
                                                                            invoiceDetails
                                                                                .invoiceProducts[0]
                                                                                ?.total_coupon_discount,
                                                                            2
                                                                        )}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) : null}

                                                        {invoiceDetails
                                                            .invoiceProducts[0]
                                                            ?.total_credit_discount ? (
                                                            <tr>
                                                                <td
                                                                    className="left"
                                                                    align="right"
                                                                >
                                                                    <span className="text-dark">
                                                                        {
                                                                            'Wallet Discount'
                                                                        }
                                                                    </span>
                                                                </td>
                                                                <td className="right">
                                                                    <span className="text-dark">
                                                                        {currencyFormat(
                                                                            invoiceDetails
                                                                                .invoiceProducts[0]
                                                                                ?.total_credit_discount,
                                                                            2
                                                                        )}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) : null}

                                                        {invoiceDetails
                                                            .cartValues
                                                            .total_paid ? (
                                                            <tr>
                                                                <td
                                                                    className="left"
                                                                    align="right"
                                                                >
                                                                    <span className="text-dark">
                                                                        {t(
                                                                            'total_paid'
                                                                        )}
                                                                    </span>
                                                                </td>
                                                                <td className="right">
                                                                    <span className="text-dark">
                                                                        {/* {currencyFormat(
                                                                            invoiceDetails
                                                                                .cartValues
                                                                                .total_paid -
                                                                                (invoiceDetails
                                                                                    .invoiceProducts[0]
                                                                                    ?.total_coupon_discount ||
                                                                                invoiceDetails
                                                                                    .invoiceProducts[0]
                                                                                    ?.total_credit_discount
                                                                                    ? invoiceDetails
                                                                                          .invoiceProducts[0]
                                                                                          ?.total_coupon_discount +
                                                                                      invoiceDetails
                                                                                          .invoiceProducts[0]
                                                                                          ?.total_credit_discount
                                                                                    : 0.0)
                                                                        )} */}
                                                                        {currencyFormat(
                                                                            parseFloat(
                                                                                invoiceDetails
                                                                                    .invoiceProducts[0]
                                                                                    ?.total_credit_discount ||
                                                                                    0
                                                                            ) +
                                                                                parseFloat(
                                                                                    invoiceDetails
                                                                                        .invoiceProducts[0]
                                                                                        ?.total_card_discount ||
                                                                                        0
                                                                                ),
                                                                            2
                                                                        )}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) : null}
                                                    </>
                                                ) : (
                                                    <>
                                                        <tr>
                                                            <td
                                                                className="left"
                                                                align="right"
                                                            >
                                                                <span className="text-dark">
                                                                    {t('items')}
                                                                </span>
                                                            </td>
                                                            <td className="right">
                                                                <span className="text-dark">
                                                                    {
                                                                        invoiceDetails
                                                                            .invoiceProducts
                                                                            .length
                                                                    }
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                className="left"
                                                                align="right"
                                                            >
                                                                <span className="text-dark">
                                                                    {t(
                                                                        'subtotal'
                                                                    )}
                                                                </span>
                                                            </td>
                                                            <td className="right">
                                                                <span className="text-dark">
                                                                    {currencyFormat(
                                                                        invoiceDetails
                                                                            .cartValues
                                                                            .per_total
                                                                    )}
                                                                </span>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td
                                                                className="left"
                                                                align="right"
                                                            >
                                                                <span className="text-dark">
                                                                    ZB Fee
                                                                    {/* {invoiceDetails
                                                                        .invoiceProducts
                                                                        .length ? (
                                                                        <>
                                                                            {' '}
                                                                            (
                                                                            {
                                                                                invoiceDetails
                                                                                    .invoiceProducts[0]
                                                                                    .buyer_premium_percent
                                                                            }
                                                                            % )
                                                                        </>
                                                                    ) : null} */}
                                                                </span>
                                                            </td>
                                                            <td className="right">
                                                                <span className="text-dark">
                                                                    {currencyFormat(
                                                                        invoiceDetails
                                                                            .cartValues
                                                                            .total_premium
                                                                    )}
                                                                </span>
                                                            </td>
                                                        </tr>

                                                        {invoiceDetails
                                                            .invoiceProducts[0]
                                                            ?.total_coupon_discount ? (
                                                            <tr>
                                                                <td
                                                                    className="left"
                                                                    align="right"
                                                                >
                                                                    <span className="text-dark">
                                                                        {
                                                                            'Promo Discount'
                                                                        }
                                                                    </span>
                                                                </td>
                                                                <td className="right">
                                                                    <span className="text-dark">
                                                                        {currencyFormat(
                                                                            invoiceDetails
                                                                                .invoiceProducts[0]
                                                                                ?.total_coupon_discount,
                                                                            2
                                                                        )}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) : null}

                                                        {invoiceDetails
                                                            .invoiceProducts[0]
                                                            ?.total_coupon_discount ? (
                                                            <tr>
                                                                <td
                                                                    className="left"
                                                                    align="right"
                                                                >
                                                                    <span className="text-dark">
                                                                        {
                                                                            'Total After Discount'
                                                                        }
                                                                    </span>
                                                                </td>
                                                                <td className="right">
                                                                    <span className="text-dark">
                                                                        {currencyFormat(
                                                                            parseFloat(
                                                                                parseFloat(
                                                                                    invoiceDetails
                                                                                        .cartValues
                                                                                        .per_total_after_discount
                                                                                ) +
                                                                                    parseFloat(
                                                                                        invoiceDetails
                                                                                            .cartValues
                                                                                            .total_premium
                                                                                    )
                                                                            ).toFixed(
                                                                                2
                                                                            ) ||
                                                                                '0.00',
                                                                            2
                                                                        )}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) : null}

                                                        {invoiceDetails
                                                            .cartValues
                                                            .total_tax ? (
                                                            <tr>
                                                                <td
                                                                    className="left"
                                                                    align="right"
                                                                >
                                                                    <span className="text-dark">
                                                                        Tax
                                                                        {/* {invoiceDetails
                                                                            .invoiceProducts
                                                                            .length ? (
                                                                            <>
                                                                                {' '}
                                                                                (
                                                                                {
                                                                                    invoiceDetails
                                                                                        .invoiceProducts[0]
                                                                                        .tax_percent
                                                                                }

                                                                                %
                                                                                )
                                                                            </>
                                                                        ) : null} */}
                                                                    </span>
                                                                </td>
                                                                <td className="right">
                                                                    <span className="text-dark">
                                                                        {currencyFormat(
                                                                            invoiceDetails
                                                                                .cartValues
                                                                                .total_tax
                                                                        )}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) : null}

                                                        {/* <tr>
                                                            <td
                                                                className="left"
                                                                align="right"
                                                            >
                                                                <span className="text-dark">
                                                                    {t(
                                                                        'total_amount'
                                                                    )}
                                                                </span>
                                                            </td>
                                                            <td className="right">
                                                                <span className="text-dark">
                                                                    {currencyFormat(
                                                                        invoiceDetails
                                                                            .cartValues
                                                                            .total_amount
                                                                    )}
                                                                </span>
                                                            </td>
                                                        </tr> */}
                                                        {invoiceDetails
                                                            .cartValues
                                                            .total_deposit ? (
                                                            <tr>
                                                                <td
                                                                    className="left"
                                                                    align="right"
                                                                >
                                                                    <span className="text-dark">
                                                                        {t(
                                                                            'bid_deposit'
                                                                        )}
                                                                    </span>
                                                                </td>
                                                                <td className="right">
                                                                    <span className="text-dark">
                                                                        -{' '}
                                                                        {currencyFormat(
                                                                            invoiceDetails
                                                                                .cartValues
                                                                                .total_deposit
                                                                        )}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) : null}

                                                        {invoiceDetails
                                                            .invoiceProducts[0]
                                                            ?.total_credit_discount ? (
                                                            <tr>
                                                                <td
                                                                    className="left"
                                                                    align="right"
                                                                >
                                                                    <span className="text-dark">
                                                                        {
                                                                            'Wallet Paid'
                                                                        }
                                                                    </span>
                                                                </td>
                                                                <td className="right">
                                                                    <span className="text-dark">
                                                                        {currencyFormat(
                                                                            invoiceDetails
                                                                                .invoiceProducts[0]
                                                                                ?.total_credit_discount,
                                                                            2
                                                                        )}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) : null}

                                                        {invoiceDetails
                                                            .invoiceProducts[0]
                                                            ?.total_card_discount &&
                                                        parseFloat(
                                                            invoiceDetails
                                                                .invoiceProducts[0]
                                                                ?.total_card_discount
                                                        ) > 0 ? (
                                                            <tr>
                                                                <td
                                                                    className="left"
                                                                    align="right"
                                                                >
                                                                    <span className="text-dark">
                                                                        {
                                                                            'Card Paid'
                                                                        }
                                                                    </span>
                                                                </td>
                                                                <td className="right">
                                                                    <span className="text-dark">
                                                                        {currencyFormat(
                                                                            invoiceDetails
                                                                                .invoiceProducts[0]
                                                                                ?.total_card_discount,
                                                                            2
                                                                        )}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) : null}

                                                        {invoiceDetails
                                                            .cartValues
                                                            .total_paid ? (
                                                            <tr>
                                                                <td
                                                                    className="left"
                                                                    align="right"
                                                                >
                                                                    <span className="text-dark">
                                                                        {t(
                                                                            'total_paid'
                                                                        )}
                                                                    </span>
                                                                </td>
                                                                <td className="right">
                                                                    <span className="text-dark">
                                                                        {/* {currencyFormat(
                                                                            invoiceDetails
                                                                                .cartValues
                                                                                .total_paid -
                                                                                (invoiceDetails
                                                                                    .invoiceProducts[0]
                                                                                    ?.total_coupon_discount ||
                                                                                invoiceDetails
                                                                                    .invoiceProducts[0]
                                                                                    ?.total_credit_discount
                                                                                    ? invoiceDetails
                                                                                          .invoiceProducts[0]
                                                                                          ?.total_coupon_discount -
                                                                                      invoiceDetails
                                                                                          .invoiceProducts[0]
                                                                                          ?.total_credit_discount
                                                                                    : 0.0)
                                                                        )} */}
                                                                        {/* {currencyFormat(
                                                                            invoiceDetails
                                                                                .cartValues
                                                                                .total_paid
                                                                        )} */}
                                                                        {/* {currencyFormat(
                                                                            invoiceDetails
                                                                                .cartValues
                                                                                .total_paid -
                                                                            (invoiceDetails
                                                                                .invoiceProducts[0]
                                                                                ?.total_coupon_discount ||
                                                                                invoiceDetails
                                                                                    .invoiceProducts[0]
                                                                                    ?.total_credit_discount
                                                                                ? invoiceDetails
                                                                                    .invoiceProducts[0]
                                                                                    ?.total_coupon_discount +
                                                                                invoiceDetails
                                                                                    .invoiceProducts[0]
                                                                                    ?.total_credit_discount
                                                                                : 0.0)
                                                                        )} */}
                                                                        {currencyFormat(
                                                                            parseFloat(
                                                                                invoiceDetails
                                                                                    .invoiceProducts[0]
                                                                                    ?.total_credit_discount ||
                                                                                    0
                                                                            ) +
                                                                                parseFloat(
                                                                                    invoiceDetails
                                                                                        .invoiceProducts[0]
                                                                                        ?.total_card_discount ||
                                                                                        0
                                                                                ),
                                                                            2
                                                                        )}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) : null}

                                                        {invoiceDetails
                                                            .cartValues
                                                            .total_due_amount ? (
                                                            <tr>
                                                                <td
                                                                    className="left"
                                                                    align="right"
                                                                >
                                                                    <span className="text-dark">
                                                                        {t(
                                                                            'pending_amount'
                                                                        )}
                                                                    </span>
                                                                </td>
                                                                <td className="right">
                                                                    <span className="text-dark">
                                                                        {currencyFormat(
                                                                            invoiceDetails
                                                                                .cartValues
                                                                                .total_due_amount
                                                                        )}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) : null}
                                                    </>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h4 className="thankText">
                        {t('thank_you_for_shopping_with_us')}
                    </h4>
                    {logsBody?.length ? (
                        <div className="noPrint">
                            <h3 className="invChangeTitle">
                                Invoice Change Logs
                            </h3>
                            <CustomTable
                                formik={buynowLogsFormik.values}
                                tableBody={logsBody}
                                tableValues={logsTableBody}
                                tableActions={[]}
                                allData={tableAllLogsBody}
                                isLoading={isLoading}
                                loadingTemplate={'table'}
                                changeTableFunction={searchTableFetch}
                                fromVariable="buynow_logs"
                                columnStorageVariable={'table_invoice_view'}
                            />
                        </div>
                    ) : null}
                </div>
            )}

            <CustomDialog
                open={addMoreItems}
                function={() => setAddMoreItems(false)}
                title={t('add_item')}
                disableBackdropClick
                className="addItemsModal"
                handleClose={handleCloseMoreItems}
            >
                {addMoreItemsFormik.values.product_title ? (
                    <>
                        <h5>{addMoreItemsFormik.values.product_title}</h5>
                    </>
                ) : null}
                <div className="row wnrDialog mb-3">
                    {Object.values(mapData(addMoreItemsFields))}
                </div>
                <div className="scanLpn">
                    <Divider />
                    <span className="or">OR</span>
                </div>
                <Button className="scanLpnBtn" onClick={handleScanProduct}>
                    <span className="material-icons">photo_camera</span> Scan
                    LPN Number
                </Button>
                <div className="row wnrDialog mb-3">
                    {Object.values(mapData(itemsQuantityField))}
                </div>
                <div className="actionWrapper">
                    <Button
                        id="add_items_cancel"
                        onClick={() => handleCloseMoreItems()}
                    >
                        Cancel
                    </Button>
                    <PrimaryButton
                        disabled={!addMoreItemsFormik.isValid}
                        onClick={() => addMoreItemsFormik.handleSubmit()}
                        type="button"
                        label={'Add'}
                    />
                </div>
            </CustomDialog>
            <CustomDialog
                title={'Change Item Tax Amounts'}
                open={taxEditPopup}
                function={changeTaxEditPopup}
                className="taxEntryModal"
            >
                <div className="row">
                    {Object.values(mapData(taxEditField))}
                </div>
                <div className="actionWrapper">
                    <Button
                        id="tax_cancel"
                        onClick={() => handleChangeAmount({}, 'closePopup')}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikTaxEdit.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="tax_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
            <BarCodeScan
                scanToggle={scanToggle}
                changeScanDialogStatus={changeScanDialogStatus}
                setDecodedBarcode={setDecodedBarcode}
            />
        </Layout>
        // </FullScreenPopup>
    )
}

export default InvoiceView
